<template>
	<div class="icon-gold-circle rounded-full">
	</div>
</template>

<script>
export default {
	name: 'IconGoldCircle',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},
	},

	watch: {
		sizeMultiplier_prop(newValue) {
			const el = document.querySelector('.icon-gold-circle')
			el.style.width = String(newValue) + 'rem'
			el.style.height = String(newValue) + 'rem'
		}
	},
}
</script>

<style scoped>
.icon-gold-circle {
	width: 1rem;
	height: 1rem;
	background: linear-gradient(225deg, #FE9A00 0.78%, #985C00 100.78%);
	border: 1px solid var(--status-text-warning, #FFB900);
}
</style>